export enum ChatSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum ChatAgentCreationStep {
  BRANDING = 'branding',
  FORM_SETTINGS = 'form_settings',
  SETTINGS = 'settings',
  ANALYTICS_SETTINGS = 'analytics_settings',
  KNOWLEDGE = 'knowledge',
}
